<template>
  <div class="cate">
      <div class="cate-header"
           :style="{'background-image': `url(${handleGetBackgroundImage()})`}">
        <h1 class="cate-header-title">{{ categoryData.name }}</h1>
        <!-- 二级分类-->
        <template v-if="firstLevelList.length">
          <ul class="cate-level" style="margin-bottom: 24px;">
            <li class="cate-level-title">场景：</li>
            <li v-for="(item, firstLevelIndex) in firstLevelList"
                :key="firstLevelIndex"
                :class="{'cate-level-item-active': firstLevelIndex === cateLevelFirstIndex }"
                class="cate-level-item"
                @click="handleSetFirstLevelIndex(firstLevelIndex)">
              {{ item.name }}
            </li>
          </ul>
        </template>
        <!-- 三级分类 -->
        <template v-if="secondLevelList.length">
          <ul class="cate-level">
            <li class="cate-level-title">用途：</li>
            <li v-for="(item, secondLevelIndex) in secondLevelList"
                :key="secondLevelIndex"
                :class="{'cate-level-item-active': secondLevelIndex === cateLevelSecondIndex }"
                class="cate-level-item"
                @click="handleSetSecondLevelIndex(secondLevelIndex)">
              {{ item.name }}
            </li>
          </ul>
        </template>
      </div>
      <!-- 排序方式   -->
      <ul class="cate-sort">
        <li class="cate-sort-title">排序方式：</li>
        <li v-for="(item, key) in $options.sortTypeEnum"
            :key="key"
            :class="{'cate-sort-item-active': item.value === sortType}"
            class="cate-sort-item"
            @click="handleSetSortType(item.value)">
          {{ item.key }}
        </li>
      </ul>
      <div class="cate-content">
        <TemplateItem v-for="(item) in templateList"
                      :key="item.id"
                      class="cate-content-item"
                      :template-data="item">
        </TemplateItem>
      </div>
      <Page :current-page="currentPage"
            class="cate-page"
            :total="total"
            :page-size="pageSize"
            @page-change="handlePageChange">
      </Page>
  </div>
</template>

<script>
import { apiOfficeGetMatList } from '@/api'
import Page from '@/components/page/Page'
import TemplateItem from '@/views/components/TemplateItem'
const sortTypeEnum = {
  COMPOSITE: { key: '综合排序', value: 1 },
  HOT: { key: '热门下载', value: 2 },
  NEW: { key: '最近更新', value: 3 },
}
export default {
  name: 'Category',
  sortTypeEnum,
  components: {
    Page,
    TemplateItem
  },
  watch: {
    categoryData () {
      this.initParams()
      this.initData()
    }
  },
  data () {
    return {
      cateLevelFirstIndex: 0,
      cateLevelSecondIndex: -1,
      sortType: sortTypeEnum.COMPOSITE.value,
      currentPage: 1,
      pageSize: 10,
      total: 97,
      templateList: []
    }
  },
  props: {
    categoryData: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true
    }
  },
  created () {
    this.initParams()
    this.initData()
  },
  computed: {
    firstLevelList () {
      return this.categoryData?.list?.length
        ? this.categoryData.list
        : []
    },
    secondLevelList () {
      return this.categoryData?.list?.length &&
      this.categoryData.list[this.cateLevelFirstIndex]?.list?.length
        ? this.categoryData.list[this.cateLevelFirstIndex].list
        : []
    }
  },
  methods: {
    initParams () {
      this.cateLevelFirstIndex = 0
      if (this.secondLevelList.length) {
        this.cateLevelSecondIndex = 0
      } else {
        this.cateLevelSecondIndex = -1
      }
      this.sortType = sortTypeEnum.COMPOSITE.value
      this.total = 0
      this.currentPage = 1
    },
    handleGetBackgroundImage () {
      // eslint-disable-next-line sonarjs/no-all-duplicated-branches
      switch (this.index) {
        case 0:
          return require('../../assets/icon/cate/bg_classify1.png')
        case 1:
          return require('../../assets/icon/cate/bg_classify2.png')
        case 2:
          return require('../../assets/icon/cate/bg_classify3.png')
        case 3:
          return require('../../assets/icon/cate/bg_classify4.png')
        case 4:
          return require('../../assets/icon/cate/bg_classify5.png')
        default:
          return require('../../assets/icon/cate/bg_classify1.png')
      }
    },
    handleSetFirstLevelIndex (index) {
      this.cateLevelFirstIndex = index
      this.currentPage = 1
      if (this.secondLevelList.length) {
        this.cateLevelSecondIndex = 0
      } else {
        this.cateLevelSecondIndex = -1
      }
      this.initData()
    },
    handleSetSecondLevelIndex (index) {
      this.cateLevelSecondIndex = index
      this.currentPage = 1
      this.initData()
    },
    handleSetSortType (sortType) {
      this.sortType = sortType
      this.currentPage = 1
      this.initData()
    },
    handlePageChange (index) {
      this.currentPage = index
      this.initData()
    },
    initData () {
      apiOfficeGetMatList({
        cat1: this.categoryData.id,
        cat2: this.firstLevelList.length ? this.firstLevelList[this.cateLevelFirstIndex].id : 0,
        cat3: this.secondLevelList.length ? this.secondLevelList[this.cateLevelSecondIndex].id : 0,
        sort: this.sortType,
        page: this.currentPage,
        size: this.pageSize,
      }).then((response) => {
        // eslint-disable-next-line camelcase
        const { list, total_count: total } = response
        this.total = total
        this.templateList = list
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/style/styleMixins";
@import "../../assets/style/styleVariable";
  .cate{
    max-width: @max_page_width;
    min-width: @min_page_width;
    margin: 0 auto;
    &-header{
      padding: 40px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      &-title{
        font-size: 36px;
        font-weight: 500;
        color: #333333;
        margin-bottom: 50px;
      }
    }
    &-level{
      .flex_align_center_mixins;
      &-title{
        font-size: 16px;
        font-weight: 500;
        color: #666666;
      }
      &-item{
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        cursor: pointer;
        margin-left: 23px;

        &:hover{
          color: #333333;
          font-weight: 600;
        }
        &-active{
          color: #333333;
          font-weight: 600;
        }
      }
    }
    &-sort{
      .flex_align_center_mixins;
      margin-top: 20px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 8px;
      &-title{
        margin-left: 42px;
        font-size: 14px;
        font-weight: 400;
        color: #444444;
      }
      &-item{
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-left: 29px;
        cursor: pointer;
        &-active{
          font-weight: bold;
          color: #3D6BFF;
        }
        &:hover{
          font-weight: 600;
          color: #3D6BFF;
        }
      }
    }
    &-page{
      justify-content: center;
      margin: 50px 0;
    }
    &-content{
      clear: both;
      margin-right: -32px;
      &::after{
        content: "";
        display: block;
        height: 0;
        clear:both;
        visibility: hidden;
      }
      &-item{
        float: left;
        margin-right: 36px;
        margin-top: 24px;
      }
    }
  }
</style>
